export default /* @ngInject */ () => {
     return (val) => {
        const isNegative = parseFloat(val) < 0;
        const abs = Math.abs(val);
        const decimal = parseFloat(abs).toFixed(2);
        const format = $.number(decimal, 2, '.', ',');

        if (isNegative) {
             return `- R ${format}`;
        }

        return `R ${format}`;
    };
};